class RestAPI {
    // Initial category is 7 (Geschäftsführung)
    async fetchData(category = 7) {
        let params = `?category=${category}`;

        try {
            const response = await fetch(window.location.origin + `/wp-json/klaarnoord/v1/employees/${params}`);
            if (!response.ok) {
                console.error('Error on REST response: ' + response);
            }

            const data = await response.json();

            this._dispatchEvent(data, category);
            return data;
        } catch (err) {
            console.error('Fetch error:', err);
        }
    }

    _dispatchEvent(data, categoryId) {
        const event = new CustomEvent('employeesFetched', {
            detail: {
                apiResponse: data,
                categoryId: categoryId
            }
        });
        document.dispatchEvent(event);
    }
}

export default RestAPI;
